import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const ApplicationMenuWrapper = ({ open, closeMenu, children }) => (
  <React.Fragment>
    <div className={`ckp-application-menu-overlay ${open ? 'is-open' : ''}`} onClick={closeMenu} />
    <nav className={`ckp-application-menu ${open ? 'is-open' : ''}`}>
      <IconButton className="ckp-modal-full-close" onClick={closeMenu} color="inherit">
        <CloseIcon />
      </IconButton>
      <div className="ckp-application-menu-body">{children}</div>
    </nav>
  </React.Fragment>
);

export default ApplicationMenuWrapper;
